import React, { useState } from "react";
import PropTypes from "prop-types";

import "./alphabet-buttons.m.css";

const AlphabetButtons = ({ onClick, availableLetters, searchQuery = "" }) => {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const handleLetterClick = (letter) => () => {
    onClick(letter);
  };

  return (
    <div styleName="alphabet-container" className="alphabet-container">
      {alphabet.map((letter) => (
        <button
          key={letter}
          onClick={handleLetterClick(letter)}
          disabled={!availableLetters.includes(letter)}
          styleName={`alphabet-button ${searchQuery === letter ? "selected" : ""} ${
            !availableLetters.includes(letter) ? "disabled" : ""
          }`}
        >
          {letter}
        </button>
      ))}
    </div>
  );
};

AlphabetButtons.propTypes = {
  onClick: PropTypes.func,
  availableLetters: PropTypes.array,
  searchQuery: PropTypes.string,
};

export default AlphabetButtons;
